import { render, staticRenderFns } from "./CoachSideNav.vue?vue&type=template&id=a0e8e614&scoped=true&"
import script from "./CoachSideNav.vue?vue&type=script&lang=ts&"
export * from "./CoachSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./CoachSideNav.vue?vue&type=style&index=0&id=a0e8e614&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e8e614",
  null
  
)

export default component.exports